import { render } from "./content-loader-list.vue?vue&type=template&id=1dbf9a21&scoped=true"
import script from "./content-loader-list.vue?vue&type=script&lang=js"
export * from "./content-loader-list.vue?vue&type=script&lang=js"

import "./content-loader-list.vue?vue&type=style&index=0&id=1dbf9a21&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dbf9a21"]])

export default __exports__